import {apiUrl} from './apiUrl';
import {statistics} from './statistics';

export {apiUrl, statistics};



// WEBPACK FOOTER //
// ./src/js/config/index.js